import { useLayout } from '@/contexts/LayoutContext';

/** True when the active white-label template is layout-4 (Motorx). */
export function useIsLayout4(): boolean {
  const { currentLayout } = useLayout();
  return currentLayout === 'layout-4';
}
